import React from "react";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: "2rem" }}>
    <h2 style={{
      fontSize: "1.15rem", fontWeight: 800, color: "#7C3AED",
      marginBottom: "0.6rem", display: "flex", alignItems: "center", gap: "0.5rem",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#EC4899", display: "inline-block", flexShrink: 0 }} />
      {title}
    </h2>
    <div style={{ color: "#4b5563", fontSize: "0.92rem", lineHeight: 1.75 }}>
      {children}
    </div>
  </div>
);

const PrivacyPolicy = ({ setActiveTab }) => (
  <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#faf5ff 0%,#fdf2f8 50%,#fff7ed 100%)" }}>

    {/* Hero */}
    <div style={{
      background: "linear-gradient(135deg,#7C3AED 0%,#9333EA 50%,#EC4899 100%)",
      padding: "4rem 1.5rem 3rem", textAlign: "center", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div style={{ position: "absolute", top: 0, left: 0, width: 200, height: 200, borderRadius: "50%", background: "rgba(255,255,255,0.05)", filter: "blur(40px)" }} />
        <div style={{ position: "absolute", bottom: 0, right: 0, width: 200, height: 200, borderRadius: "50%", background: "rgba(255,255,255,0.05)", filter: "blur(40px)" }} />
      </div>
      <div style={{ position: "relative", zIndex: 1 }}>
        <span style={{
          display: "inline-block", background: "rgba(255,255,255,0.15)", color: "white",
          fontSize: "0.78rem", fontWeight: 800, padding: "0.35rem 1.1rem", borderRadius: 999,
          letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem",
        }}>🔒 Legal</span>
        <h1 style={{ fontSize: "clamp(2rem,5vw,2.8rem)", fontWeight: 900, color: "white", margin: "0 0 0.75rem" }}>
          Privacy Policy
        </h1>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem", maxWidth: 520, margin: "0 auto" }}>
          How Furpect Tails collects, uses, and protects your personal information.
        </p>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.78rem", marginTop: "0.75rem" }}>
          Last updated: October 2026
        </p>
      </div>
    </div>

    {/* Content */}
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "3rem 1.5rem" }}>
      <div style={{
        background: "white", borderRadius: "1.5rem", padding: "2.5rem",
        boxShadow: "0 4px 40px rgba(124,58,237,0.08)", border: "1px solid rgba(124,58,237,0.1)",
      }}>
        <p style={{ color: "#6b7280", fontSize: "0.9rem", lineHeight: 1.8, marginBottom: "2rem", padding: "1rem 1.25rem", background: "#faf5ff", borderRadius: "0.75rem", borderLeft: "4px solid #7C3AED" }}>
          By using the Furpect Tails website and booking system, you agree to the collection and use of information as described in this policy. We are committed to protecting your privacy and handling your data with care.
        </p>

        <Section title="1. Information We Collect">
          <p>When you register or book an appointment, we may collect:</p>
          <ul style={{ paddingLeft: "1.25rem", marginTop: "0.5rem" }}>
            <li><strong>Personal Information:</strong> Full name, email address, and phone number.</li>
            <li><strong>Pet Information:</strong> Pet name, breed, age, weight, and vaccination records.</li>
            <li><strong>Booking Details:</strong> Selected services, appointment dates, and special instructions.</li>
            <li><strong>Payment Information:</strong> Payment method and reference numbers (we do not store full payment card details).</li>
          </ul>
        </Section>

        <Section title="2. How We Use Your Information">
          <p>We use your information to:</p>
          <ul style={{ paddingLeft: "1.25rem", marginTop: "0.5rem" }}>
            <li>Process and manage your bookings and appointments.</li>
            <li>Send booking confirmations and appointment reminders.</li>
            <li>Maintain your pet's grooming and visit history.</li>
            <li>Respond to inquiries and provide customer support.</li>
            <li>Improve our services and website experience.</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </Section>

        <Section title="3. Data Sharing">
          <p>
            We do <strong>not</strong> sell, trade, or rent your personal information to third parties.
            Your data may only be shared with trusted service providers who assist us in operating our website
            and conducting our business, under strict confidentiality agreements.
          </p>
        </Section>

        <Section title="4. Data Retention">
          <p>
            We retain your personal information for as long as necessary to provide our services and comply
            with legal requirements. You may request deletion of your account and associated data at any time
            by contacting us.
          </p>
        </Section>

        <Section title="5. Security">
          <p>
            We implement reasonable security measures to protect your personal information from unauthorized
            access, disclosure, alteration, or destruction. However, no method of transmission over the Internet
            is 100% secure, and we cannot guarantee absolute security.
          </p>
        </Section>

        <Section title="6. Cookies">
          <p>
            Our website may use cookies to enhance your browsing experience and maintain your session.
            You may choose to disable cookies through your browser settings, though this may affect
            certain features of the website.
          </p>
        </Section>

        <Section title="7. Children's Privacy">
          <p>
            Our services are not directed at children under 13 years of age. We do not knowingly collect
            personal information from children. If you believe we have inadvertently collected such information,
            please contact us immediately.
          </p>
        </Section>

        <Section title="8. Changes to This Policy">
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with
            a revised "Last updated" date. Continued use of our services after changes constitutes your
            acceptance of the updated policy.
          </p>
        </Section>

        <Section title="9. Contact Us">
          <p>If you have any questions or concerns about this Privacy Policy, please contact us:</p>
          <div style={{ marginTop: "0.75rem", padding: "1rem 1.25rem", background: "#faf5ff", borderRadius: "0.75rem", border: "1px solid rgba(124,58,237,0.1)" }}>
            <p style={{ margin: 0 }}><strong>Furpect Tails Pet Grooming & Hotel</strong></p>
            <p style={{ margin: "0.25rem 0 0" }}>📍 96 Gen. Luna St., Tuktukan, Taguig City</p>
            <p style={{ margin: "0.25rem 0 0" }}>📞 0954 498 8342</p>
          </div>
        </Section>

        {/* Back button */}
        <div style={{ marginTop: "2.5rem", textAlign: "center" }}>
          <button
            onClick={() => setActiveTab("home")}
            style={{
              display: "inline-flex", alignItems: "center", gap: "0.5rem",
              background: "linear-gradient(135deg,#7C3AED,#EC4899)",
              color: "white", fontWeight: 700, fontSize: "0.9rem",
              padding: "0.75rem 2rem", borderRadius: 999, border: "none",
              cursor: "pointer", boxShadow: "0 4px 20px rgba(124,58,237,0.3)",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.04)"; e.currentTarget.style.boxShadow = "0 6px 28px rgba(124,58,237,0.4)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(124,58,237,0.3)"; }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;
